import { createStore } from 'vuex'

const IntegrationBranch = false
const TestBranch = false
const addr = TestBranch ? "api-go.samgk.ru" : "api-go.samgk.ru" // 176.99.5.230, api-go.samgk.ru
const protocol = TestBranch ? "http:" : `${location.protocol == "file:" ? "http:" : location.protocol}`

const host = IntegrationBranch ? window.location.origin : `${protocol}//${addr}`

export default createStore({
    state: {
        employeeRole: "61b6e306158a53296b55003a",
        studentRole: "620f359ce13fae5b1afaaa4e",
        listenerRole: "61b6e310158a53296b55003b",
        adminRole: "61b6e322158a53296b55003d",
        methodistRole: "61b6e317158a53296b55003c",
        apiAddr: `${host}/main_api`,
        aeApiAddr: `${host}/ae_api`,
        adminApiAddr: `${host}/system_api`,
        filesApiAddr: `${host}/files_api`,
        token: null,
        token_expires: null,
        journal_id: null,
        mode: 'light',
    },
    mutations: {
        updateToken(state) {
            state.token = localStorage.getItem("tok")
        },
        setToken(state, token) {
            localStorage.setItem("tok", token)
            state.token = localStorage.getItem("tok")
        },
        clearToken(state) {
            localStorage.removeItem("tok")
            state.token = localStorage.getItem("tok")
        },
        updateTokenExpiration(state) {
            state.token_expires = localStorage.getItem("tok_expires")
        },
        setTokenExpiration(state, expiration) {
            localStorage.setItem("tok_expires", expiration)
            state.token_expires = localStorage.getItem("tok_expires")
        },
        clearTokenExpiration(state) {
            localStorage.removeItem("tok_expires")
            state.token_expires = localStorage.getItem("tok_expires")
        },
        updateJournalID(state) {
            state.journal_id = localStorage.getItem("journal_id")
        },
        setJournalID(state, journal_id) {
            localStorage.setItem("journal_id", journal_id)
            state.journal_id = localStorage.getItem("journal_id")
        },
        clearJournalID(state) {
            localStorage.removeItem("journal_id")
            state.journal_id = localStorage.getItem("journal_id")
        },
        setMode(state, mode) {
            localStorage.setItem("mode", mode)
            state.mode = localStorage.getItem("mode")
        },
        updateMode(state) {
            const mode = localStorage.getItem("mode")
            if (mode !== null) {
                state.mode = mode
            }
        },
    },
    actions: {},
    modules: {}
})